var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{style:(("min-height:" + _vm.height)),attrs:{"type":"flex","justify":"center","align":"middle"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }